import { Lesson } from 'app/constants/schemas';
import { sessionRequest } from 'app/models/auth/actions';
import { ERROR_INVALID_LESSON } from 'app/models/entities/constants';
import { fetchEntities } from 'app/models/entities/remote';
import {
  deletedPublishedLesson,
  fetchedPublishedLessons,
  lessonPublished,
} from 'app/models/publishedLessonAdmin/actions';
import { updateFromServer } from 'app/remote/index';
import { getResponseIds } from 'app/remote/response';
import * as API from 'app/utils/api';

export const fetchPublishedLessons = (id) => fetchEntities({
  type: Lesson,
  params: API.getPublishedLessonsForLesson(id, { page_size: 0 }),
  updateAction: (response) => (dispatch) => {
    dispatch(updateFromServer(response));
    dispatch(fetchedPublishedLessons(id, getResponseIds(response)));
  },
});

export const republishLesson = (lessonID, publishedLessonID, options) => (dispatch) =>
  dispatch(sessionRequest(API.republishLesson(publishedLessonID, options)))
    .then((response) => {
      dispatch(updateFromServer(response));
      dispatch(lessonPublished(lessonID, response.data.id));
      return response;
    });

export const deletePublishedLesson = (lessonID, publishedLessonID) => (dispatch) =>
  dispatch(sessionRequest(API.deleteLesson(publishedLessonID)))
    .then((response) => {
      dispatch(deletedPublishedLesson(lessonID, publishedLessonID));
      return response;
    });

export const hidePublishedLesson = (lessonID, publishedLessonID) => (dispatch) =>
  dispatch(sessionRequest(API.hideLesson(publishedLessonID)))
    .then((response) => {
      dispatch(updateFromServer(response));
      return response;
    });

export const unhidePublishedLesson = (lessonID, publishedLessonID) => (dispatch) =>
  dispatch(sessionRequest(API.unhideLesson(publishedLessonID)))
    .then((response) => {
      dispatch(updateFromServer(response));
      return response;
    });

export const publishLesson = (id, options) => (dispatch) =>
  dispatch(sessionRequest(API.publishLesson(id, options))).then((response) => {
    dispatch(updateFromServer(response));
    dispatch(lessonPublished(id, response.data.id));
    return response;
  });

/**
 * @param {ApplicationError} applicationError
 */
export const isValidationError = (applicationError) =>
  applicationError.error.code === ERROR_INVALID_LESSON;
